import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProjectConsentSettingsContent } from '@/components/settings/consent-settings';
import { PageContent } from '@/components/page-content';
import { useProjects } from '@/hooks/use-projects';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute(
  '/_auth/_side-layout/project-settings/consent',
)({
  component: ProjectConsentRoute,
  beforeLoad: ({ context }) => {
    // Consent settings (org + per-project override) are an org-admin capability
    // on the backend, so this tab is gated to org owners/admins even though it
    // lives under Project Settings (mirrors the Revenue tab).
    if (!hasPermission(context.userRole, { organization: ['update'] })) {
      throw redirect({ to: '/project-settings/general' });
    }
  },
});

function ProjectConsentRoute() {
  const { projectId } = useProjects();
  if (!projectId) return null;

  return (
    <PageContent>
      <ProjectConsentSettingsContent projectId={projectId} />
    </PageContent>
  );
}
